<template>
  <div>
    <div class="coupon-code">
      <div class="input-coupon-code">
        <v-combobox
          v-model="form.appliedCodes"
          color="primary"
          :items="[]"
          outlined
          dense
          filled
          persistent-placeholder
          multiple
          chips
          small-chips
          hide-selected
          hide-no-data
          hide-details
          :append-icon="null"
          :disabled="
            couponRequest.isLoading ||
              form.appliedCodes.length >= couponMaxCount
          "
          :error="couponMsgError !== '' && activeErrorKey === key"
          :placeholder="couponCodePlaceholder"
          background-color="white"
          data-pptr="couponCode"
          class="input-customer text-sm pt-0"
          oninput="this.value = this.value.replace(/[^a-zA-Z0-9-_]/g, '')"
          @change="onComboboxEnter"
        >
          <template v-slot:selection="{ item }">
            <v-chip
              v-bind="{
                color:
                  isCouponCodeApplied(item) || couponRequest.isLoading
                    ? 'light-blue lighten-5'
                    : 'red lighten-1',
                textColor:
                  isCouponCodeApplied(item) || couponRequest.isLoading
                    ? 'black'
                    : 'white',
                closeIcon: 'mdi-close-circle-outline',
              }"
              class="ma-1 font-bold"
              small
              close
              @click:close="removeCouponCode(item)"
            >
              <v-icon
                v-if="isCouponCodeApplied(item)"
                small
                left
                color="green"
              >
                mdi-check-circle
              </v-icon>

              {{ item }}
            </v-chip>
          </template>
          <template v-slot:append>
            <v-progress-circular
              v-if="couponRequest.isLoading"
              :color="colorBnn['color-coupon']"
              indeterminate
              :size="20"
            ></v-progress-circular>
          </template>
        </v-combobox>
      </div>

      <div class="use-code">
        <v-btn
          depressed
          height="40px"
          class="px-6 font-bold btn-apply-coupon"
          color="primary"
          :disabled="couponRequest.isLoading"
          @click="submitCouponFromInput"
        >
          ใช้คูปอง
        </v-btn>
      </div>

      <div
        v-if="couponMsgError && activeErrorKey === key"
        class="coupon-msg-error"
      >
        <span>{{ couponMsgError }}</span>
        <span
          v-if="form.appliedCodes.length >= couponMaxCount"
          class="ml-1"
          >ใช้โค้ดได้สูงสุด {{ couponMaxCount }} โค้ด</span
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { validationMixin } from 'vuelidate'
import cartSummary from '@/mixins/cartSummary'
import colorBnn from '@/config/color'

export default {
  name: 'CheckoutApplyCoupon',

  mixins: [validationMixin, cartSummary],

  props: {
    key: {
      type: String,
      default: 'summary-main',
      required: true,
    },
    label: {
      type: String,
      default: 'กรอกคูปองส่วนลด',
    },
  },

  data() {
    return {
      // Import
      colorBnn,

      form: {
        appliedCodes: this.$store.state.cart.coupons.map(c => c.code),
      },
      couponMaxCount: 3,
      freebieListByCouponModal: false,

      activeErrorKey: null,
    }
  },

  computed: {
    ...mapState({
      selectSKU: state => state.model.selectSKU,
      branchType: state => state.branchStore.branchType,
      coupons: state => state.cart.coupons,
      couponRequest: state => state.cart.couponRequest,
      cartDelivery: state => state.cart.delivery,
      cartSummaryData: state => state.cart.cartSummaryData,
      paymentTypeData: state => state.paymentType.data,
      paymentId: state => state.paymentType.paymentId,
      selectBundleDelivery: state => state?.bundle.delivery,
      campaign: state => state.campaign.current,
      selects: state => state.bundle.selects,
      productId: state => state.order.data?.product_main?.id,
      memberId: state => state.order.data?.member_id,
      orderCoupons: state => state.order.data?.coupons,
    }),

    ...mapGetters({
      bundles: 'model/getBundles',
      additionalProduct: 'model/getAdditionalProduct',
      appleCare: 'model/getAppleCare',
      cartItems: 'cart/cartItems',
      productItem: 'cart/productItem',
      priceSummary: 'cart/priceSummary',
      isSoldOut: 'model/getSoldOut',
      bundleItems: 'cart/bundleItems',
      discountOnTop: 'cart/discountOnTop',
      deliveryItems: 'cart/deliveryItems',
      getBundleDelivery: 'model/getBundleDelivery',
      accessoryBundles: 'model/getAccessoryBundles',
      // getFreebieHandraiser
      handraiserFreebies: 'model/getHandraiserFreebies' ?? [],
    }),

    isSamsungHandraiser() {
      return (
        this.campaign?.data?.handraiser &&
        this.campaign?.data?.handraiser === 'samsung'
      )
    },

    forceCoupon() {
      return (
        this.campaign?.data?.force_coupon ?? ''
        // this.couponCodeParam ??
      )
    },

    couponCodePlaceholder() {
      return this.isSamsungHandraiser
        ? 'ใช้ Handraiser Code ที่นี่'
        : 'กรอกโค้ดส่วนลด'
    },

    couponMsgError() {
      if (this.couponRequest.status === 422) {
        return !this.freebieListByCouponModal
          ? this.couponRequest.message
          : ''
      } else if (this.couponRequest.isError) {
        return 'โค้ดไม่ถูกต้อง'
      }
      return ''
    },

    decryptedData() {
      return this.$store.getters['user/getData']
    },
  },

  async mounted() {
    const paymentId =
      this.paymentId ||
      this.paymentTypeData?.filter(i =>
        this.isDeposit
          ? i.type === 'deposit'
          : this.$route.query.t
          ? i.type === 'pay-at-store'
          : i.type !== 'deposit',
      )?.[0]?.id

    this.$store.commit('paymentType/setPaymentId', paymentId)

    // Hide for now — the auto-force-coupon-on-mount flow doesn't fit the
    // multi-code model, matching bnn's port.
    // if (this.forceCoupon) {
    //   await this.submitCoupon()
    // }

    // Force coupons for checkout route
    if (
      this.$route.name === 'Checkout' &&
      this.orderCoupons.length > 0
    ) {
      this.form.appliedCodes = this.orderCoupons.map(c => c.code)
      await this.submitCoupon()
    }
  },

  methods: {
    async submitCoupon() {
      const appliedCodes = this.form.appliedCodes
        ? [...this.form.appliedCodes]
        : []

      const filteredCodes = appliedCodes.filter(
        (code, index) =>
          appliedCodes.findIndex(
            c => c.toLowerCase() === code.toLowerCase(),
          ) === index,
      )

      this.form.appliedCodes = filteredCodes

      // If no coupon codes are applied, we can skip the API call and just recalculate the summary
      if (filteredCodes.length === 0) {
        this.$store.commit('cart/resetCouponCode')
        this.checkSummary()
        return true
      }

      const payload = {
        productId: this.selectSKU?.id ?? this.productId,
        appliedCodes: filteredCodes,
        paymentTypeId:
          this.formCheckSummary?.payment_type_id ?? this.paymentId,
        memberId:
          this.decryptedData?.member_id ?? this.memberId ?? null,

        // If not VIP, check if the route has a query parameter for code to determine if it's a stock card
        isStockCard: !!this.$route.query?.code || false,
        bundleItems: this.bundleItems,
      }

      const result = await this.$store.dispatch(
        'cart/addCouponCode',
        payload,
      )

      if (result.success) {
        await this.HandleFreebieWithCoupon('add')
      } else {
        this.activeErrorKey = this.key
      }

      this.checkSummary()

      return result.success
    },

    async submitCouponFromInput() {
      await this.submitCoupon()
    },

    onComboboxEnter() {
      this.submitCouponFromInput()
    },

    async removeCouponCode(couponCode) {
      this.form.appliedCodes = this.form.appliedCodes.filter(
        code => code.toLowerCase() !== couponCode.toLowerCase(),
      )

      // Remove freebie items associated with the removed coupon code
      await this.HandleFreebieWithCoupon('remove', couponCode)

      // Remove the coupon code from the store
      this.$store.commit('cart/removeCoupon', couponCode)

      // Submit coupon again to recalculate discounts based on the new bundle composition
      await this.submitCoupon()
    },

    isCouponCodeApplied(code) {
      return this.coupons.some(
        c => c.code.toLowerCase() === code.toLowerCase(),
      )
    },

    HandleFreebieWithCoupon(key, code) {
      const appliedCodes = this.coupons ?? []

      switch (key) {
        case 'remove': {
          const removedCoupon = appliedCodes.find(
            c => c.code.toLowerCase() === code.toLowerCase(),
          )

          if (removedCoupon) {
            const gifts = removedCoupon?.autoAddToCart ?? []
            if (gifts.length > 0) {
              this.handraiserFreebies
                ?.filter(item => gifts.includes(item.sku))
                .forEach(item => {
                  this.$store.dispatch('bundle/remove', item)
                })
            }
          }
          break
        }
        default: {
          appliedCodes.forEach(coupon => {
            const gifts = coupon?.autoAddToCart ?? []
            if (gifts.length === 0) return

            this.handraiserFreebies
              ?.filter(item => gifts.includes(item.sku))
              .forEach(item => {
                this.$store.dispatch('bundle/add', item)
              })
          })
          break
        }
      }
    },
  },

  watch: {
    coupons: {
      handler() {
        this.form.appliedCodes = this.coupons.map(c => c.code)
      },
      deep: true,
    },
  },
}
</script>

<style lang="stylus" scoped>
.coupon-code
    display: flex
    flex-wrap: wrap
    align-items: flex-end
    gap: 12px 16px
    .input-coupon-code
        flex: 1
        min-width: 220px
    .use-code
        flex: none

.coupon-msg-error
  flex-basis: 100%
  color: red
  font-size: 14px

.coupon-msg-success
  flex-basis: 100%
  font-size: 14px
  font-weight: bold

.coupon-msg-max-limit
  font-size: 14px
  font-weight: bold

.text-white
  color: #fff !important

::v-deep .v-autocomplete:not(.v-input--is-focused).v-select--chips input
  max-height: unset !important
</style>
